module.exports = __webpack_public_path__ + "assets/fe221de92d86a334adeab5cfbea14d9d.png";